<template>
  <div class="store-intent-container">
    <nav-bar></nav-bar>

    <div class="container">

      <div class="section">

        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li><a @click="$router.push('/clients')">{{ CONSTANTS.getCopy('UPDATEINTENT_BREADCRUMB_CHATBOTS') }}</a></li>
            <li><a @click="$router.push('/clients/' + client + '/intents')">{{ clientName }}</a></li>
            <li><a @click="$router.push('/clients/' + client + '/intents')">{{ CONSTANTS.getCopy('UPDATEINTENT_BREADCRUMB_INTENTS') }}</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('UPDATEINTENT_EDIT_INTENT') }}</a></li>
          </ul>
        </nav>

        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('UPDATEINTENT_FIELD_NAME_LABEL') }}</label>
          <div class="control">
            <input class="input" type="text" v-bind:placeholder="CONSTANTS.getCopy('UPDATEINTENT_FIELD_NAME_PLACEHOLDER') " v-model="intent.name" />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('UPDATEINTENT_FIELD_DESCRIPTION_LABEL') }}</label>
          <div class="control">
            <textarea  v-bind:placeholder="CONSTANTS.getCopy('UPDATEINTENT_FIELD_DESCRIPTION_PLACEHOLDER') " maxlength="150" v-model="intent.description">
            </textarea>
          </div>
        </div>

        <div class="field theme-section">
          <label class="label">{{ CONSTANTS.getCopy('UPDATEINTENT_FIELD_THEME_LABEL') }}</label>
          <div class="control">
            <select v-model="intent.idGroupIntent">
              <option v-for="(group, index) in intentsGroups" :key="index" :value="parseInt(group.id)">{{group.name}}</option>
            </select>
            <input type="text" v-bind:placeholder="CONSTANTS.getCopy('UPDATEINTENT_FIELD_THEME_PLACEHOLDER') " v-model="intent.nameGroupIntent"/>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('UPDATEINTENT_FIELD_MINUTES_LABEL') }}</label>
          <div class="control">
            <input class="input" type="text" v-bind:placeholder="CONSTANTS.getCopy('UPDATEINTENT_FIELD_MINUTES_PLACEHOLDER') " v-model="intent.minutes" />
          </div>
        </div>

        <br>

        <div class="button is-primary is-left" @click="updateIntent">
          <span class="icon"><i class="fas fa-save fa-lg"></i></span>
          <span class="is-capitalized">{{ CONSTANTS.getCopy('UPDATEINTENT_SAVE_BUTTON') }}</span>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
export default {
  data () {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      intentsGroups: [],
      intent: {
        idIntent: null,
        name: null,
        description: null,
        minutes: null,
        idGroupIntent: 0,
        nameGroupIntent: null
      }
    }
  },
  created () {
    this.breadcrumbDetails()
    this.api.post('/IntentById', { idIntent: this.$route.params.intent }).then(response => {
      this.intent = response.intent
    })
    this.getGroupIntents()
  },
  methods: {
    breadcrumbDetails () {
      this.api.post('/ClientById/', { idClient: this.client }).then(response => {
        this.clientName = response.client.name
      })
    },
    updateIntent () {
      if (this.intent.nameGroupIntent !== null) {
        this.intent.idGroupIntent = 0
      }
      this.api.post('/IntentUpdate', this.intent).then(() => {
        this.$router.go(-1)
      })
    },
    getGroupIntents () {
      this.api.post('/DataIntentsGroupList', {idClient: this.client, newIntent: 1}).then((response) => {
        this.intentsGroups = response.intentsgroups
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/UpdateIntent.vue